PegasusTemplate.TemplateContentView = Ember.View.extend({
  classNames: ['vr-template-content'],
  controllerBinding: 'parentView.controller',
  template: function(){
    return Ember.Handlebars.compile( this.get('controller.content.html') );
  }.property(),
  isVisible: true,

  isReady: false,

  bindClickEditingBehavior: function(){
    $('.center-wrapper-container').on('click.' + this.get('elementId'), function(e){
      if ( $(e.target).hasClass('center-wrapper-container') ) {
        Em.run(PegasusTemplate.stateMachine, 'send', 'didFinishEditing');
      }
    });
  },

  bindBlockHiding: function(){
    $(window).on([
      'didToggleImageDisplayMode.' + this.get('elementId'),
      'considerHidden.' + this.get('elementId')
    ].join(' '), function(){
      Em.run.scheduleOnce('afterRender', this, 'updateHasHidden');
    }.bind(this));
  },

  updateHasHidden: function(){
    if ( this.$('.user-hidden').length ) {
      this.set('controller.hasHidden', true);
      return;
    }
    this.set('controller.hasHidden', false);
  },

  unbindBlockHiding: function(){
    $(window).off([
      'didToggleImageDisplayMode.' + this.get('elementId'),
      'considerHidden.' + this.get('elementId')
    ].join(' '))
  },

  unbindWrapperClick: function(){
    $('.center-wrapper-container').off('click.' + this.get('elementId'));
  },

  willDestroyElement: function(){
    this.unbindBlockHiding();
    this.unbindWrapperClick();
    this._super();
  },

  didInsertElement: function(){
    this._super();

    // we have a lot of didInsert logic so let the dust
    // settle before allowing any interactio
    PegasusTemplate.set('status', 'editing');

    if( PegasusTemplate.stateMachine.isDone ){
      PegasusTemplate.stateMachine.isDone();
    }

    this.bindClickEditingBehavior();
    this.bindBlockHiding();

    Em.run.scheduleOnce('afterRender', this, 'updateHasHidden');
    Em.run.scheduleOnce('afterRender', this, 'defineUserSelectedColors');
    Em.run.scheduleOnce('sync', PegasusTemplate.lookupController('frameCommManager'), 'sendTemplateRenderingOptions');
  },
  defineUserSelectedColors: function(){
    this.get('controller').locateTemplateColors();
  }
});

PegasusTemplate.TemplateView = Ember.View.extend({
  classNames: ['editor-container'],
  templateName: 'template/index',
  contentView: PegasusTemplate.TemplateContentView,
  didInsertElement: function(){
    this._super();
    this.get('controller').applyFontFace();
  }
});
